import styled from 'styled-components';
import React from 'react';
import { TextWithTooltip } from '@ubeya/shared-web/components';
import { CostCentersSelectField as BaseCostCentersSelectField } from '../../../shared/components/AddNewSelectors';

const CostCentersSelectField = styled(BaseCostCentersSelectField)`
  flex: 1;
  grid-area: label;
`;

const Text = styled(TextWithTooltip)`
  padding-left: 10px;
  font-size: 12px;
`;

const CostCenterSection = ({
  name,
  required,
  validate,
  value,
  isDisabled = false,
  hideTitle = false,
  hideBorder = false
}) => {
  if (isDisabled) {
    return <Text>{value?.name || value?.identifier || ''}</Text>;
  }

  return (
    <CostCentersSelectField
      hideBorder={hideBorder}
      name={name}
      hideTitle={hideTitle}
      required={required}
      validate={validate}
    />
  );
};

export default CostCenterSection;
